const SettingsShiftsPage = () => import('frontend/pages/settings/shifts/SettingsShiftsPage')
const SettingsSystemsPage = () => import('frontend/pages/settings/SettingsSystemsPage')


export const settingsShiftRoutesOptions = [
  {
    path: 'shift-management',
    name: 'settings-shifts',
    component: SettingsShiftsPage,
  },
]

export const settingsSystemRoutesOptions = [
  {
    path: 'system',
    name: 'settings-system',
    component: SettingsSystemsPage,
    props: { source: 'people' },
  },
]
